import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "broadcast_container"
}
const _hoisted_2 = { class: "list_wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item_img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "item_content" }
const _hoisted_7 = { class: "content_title" }
const _hoisted_8 = { class: "content_author" }
const _hoisted_9 = { class: "content_label" }
const _hoisted_10 = { class: "label_time" }
const _hoisted_11 = { class: "label_count" }

import { computed } from 'vue'
import CardTitle from './CardTitle.vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useRouter } from 'vue-router'
import { addViewCountReq, addUvCountReq } from '@/api/requests/BroadRequests'
import { sandsTalkNativeUrl, sandsTalkVnNativeUrl } from '@/utils/sandsTalkNative'
import { isSandsTalkPhOutfieldApp, sandsTalkPhOpenUrl } from '@/utils/sandsTalkPhOutfiled'
import { isWisdomRabbitApp, wisdomRabbitGoToNativeLoadUrl } from '@/utils/sandsTalkSmartRabbit'
import { brMexOutFieldNativeUrl, isSandsTalkBrMexApp } from '@/utils/sandsTalkBRMXOutfiled'
import { branchManagerGoToNativeLoadUrl, isBranchManagerApp } from '@/utils/sandsTalkBranchManager'
import { isIOS } from '@/utils/Device'
import { isSandsTalkMSFlutterApp, sandsTalkMSOpenUrl } from '@/utils/sandsTalkMSFlutter'
interface TItem {
  id: string
  articleType: number
  jumpUrl: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Broadcast',
  props: {
    data: {}
  },
  setup(__props: any) {

const SandsTalkUserInfo = JSON.parse(localStorage.getItem('SandsTalkUserInfo') || '{}')

const props = __props

const router = useRouter()
const skipHandle = async (item: TItem) => {
  addUvCountReq({
    id: item.id
  })
  if (item.articleType === 1 && item.jumpUrl && item.jumpUrl.length > 0) {
    try {
      const res = await addViewCountReq({ id: item.id })
      if (res?.code === 1) {
        // 行业动态 泰国外场
        if (SandsTalkUserInfo.source === 'ThOutfield') {
          sandsTalkNativeUrl(item.jumpUrl)
        } else if (isWisdomRabbitApp) {
          wisdomRabbitGoToNativeLoadUrl(item.jumpUrl)
        } else if (isBranchManagerApp) {
          // 网点管家
          branchManagerGoToNativeLoadUrl(item.jumpUrl)
        } else if (isSandsTalkPhOutfieldApp) {
          // 菲律宾外场
          sandsTalkPhOpenUrl(item.jumpUrl)
        } else if (window.jt || (!window.jt && window.flutter_inappwebview)) {
          // 越南外场
          sandsTalkVnNativeUrl(item.jumpUrl)
        } else if (isSandsTalkBrMexApp) {
          // 巴西、墨西哥、埃及外场
          if (isIOS) {
            brMexOutFieldNativeUrl(item.jumpUrl)
          } else {
            window.location.href = item.jumpUrl
          }
        } else if (isSandsTalkMSFlutterApp) {
          // 马来 兔学堂
          sandsTalkMSOpenUrl(item.jumpUrl)
        } else {
          window.location.href = item.jumpUrl
        }
      }
    } catch (error) {
      console.error('Error adding view count:', error)
    }
  } else {
    router.push('/broadcastDetail/' + item.id)
  }
}
const broadcastData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const dataJumpCategoryIds = computed(() => {
  try {
    return props.data.lmsDecorateModuleCategories[0].dataJumpCategoryIds.join(',')
  } catch (error) {
    return ''
  }
})

const dataShowRule = computed(() => {
  try {
    return props.data.lmsDecorateModuleCategories[0].dataShowRule
  } catch (error) {
    return '0'
  }
})

return (_ctx: any,_cache: any) => {
  return (broadcastData.value && broadcastData.value.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CardTitle, {
          title: __props.data.title,
          skipPage: '/broadcast?dataJumpCategoryIds=' + dataJumpCategoryIds.value + '&dataShowRule=' + dataShowRule.value
        }, null, 8, ["title", "skipPage"]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(broadcastData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list_item",
              key: item.id,
              onClick: ($event: any) => (skipHandle(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "img",
                  src: item.coverImgUrl
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.author), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.releaseTime), 1),
                  _createElementVNode("span", _hoisted_11, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_guankanrenshu" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(item.viewCount), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})